<template>
  <footer class="footer">
    <div class="container">
      <div class="content">
        <div class="columns is-centered has-text-centered">
          <div class="column is-narrow">
            <i class="fa fa-copyright"></i>
            {{$utils.thisYear()}} Copyright.
          </div>
          <div class="column is-narrow">
            <a target="_blank" href="http://www.miitbeian.gov.cn/">粤ICP备12001590号-7</a>
          </div>
          <div class="column is-narrow">
            <a target="_blank" href="http://www.cac.gov.cn/2019-03/30/c_1124305122.htm">粤网信备 44010619364570180015 号</a>
          </div>
          <div class="column is-narrow">
            广东格兰堂信息科技有限公司
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'footer-bar'
  }
</script>

<style lang="scss" scoped>
  .footer {
    z-index: 100;
    color: #aaa;
    padding: 3.8rem 1.5rem 3.8rem;
  }
  .fa-heart {
    color: red;
  }

  .handwriting {
    font-family: "Dancing Script", cursive;
  }

  a {
    color: #aaa;
  }
</style>




// WEBPACK FOOTER //
// src/components/layout/FooterBar.vue